import { render, staticRenderFns } from "./OrdersTransportDuplicate.vue?vue&type=template&id=26291d1a&"
import script from "./OrdersTransportDuplicate.vue?vue&type=script&lang=js&"
export * from "./OrdersTransportDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports